function CategoryButton({ icon, name, nameTr, isActive, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center p-2 rounded-2xl transition-all group
        duration-300 transform hover:scale-105 mb-2 shadow-md hover:shadow-lg group ${
          isActive
            ? "bg-purple-500 text-white "
            : "bg-yellow-500 hover:bg-purple-500 group-hover:text-white"
        } overflow-y-auto`}
      style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
    >
      <span
        className={`text-xl mr-2 w-10 h-10 rounded-full flex justify-center items-center transition-colors ${
          isActive ? "bg-yellow-500" : "bg-purple-500 group-hover:bg-yellow-500"
        }`}
      >
        {icon}
      </span>

      <div className="flex flex-col">
        <span
          className={`font-semibold text-gray-700 group-hover:text-white border-b-2
        border-purple-500 text-base group-hover:border-yellow-500 pb-0.5 inline-block w-fit ${
          isActive
            ? " text-white border-yellow-500"
            : "text-gray-700 group-hover:text-white "
        }`}
        >
          {name}
        </span>
        <p className="text-sm group-hover:text-white">{nameTr}</p>
      </div>
    </button>
  );
}

export default CategoryButton;
